var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFalabellaDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5089 48.7958C28.3108 48.7958 7.4668 43.1882 7.4668 36.2698C7.4668 29.3584 28.3108 23.7524 35.5089 23.7524C42.6985 23.7524 48.5312 29.3584 48.5312 36.2698C48.5312 43.1882 42.6985 48.7958 35.5089 48.7958Z",
    fill: "#CFDBEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0851 28.4589C24.4072 25.7218 13.1381 14.1498 15.987 9.65135C18.8275 5.15287 34.6985 9.41868 39.3849 12.1643C44.0627 14.8867 45.5631 20.758 42.7142 25.2565C39.8737 29.7635 33.7714 31.1975 29.0851 28.4589Z",
    fill: "#CFDBEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.147 25.4341C26.638 26.7711 28.0314 27.8405 29.0883 28.459C33.6276 31.1117 39.4956 29.8494 42.4407 25.6715C40.4334 24.4558 38.0569 23.7524 35.5102 23.7524C33.1312 23.7524 29.2618 24.3647 25.147 25.4341Z",
    fill: "#B8C5D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFalabellaDisabled);
export default __webpack_public_path__ + "static/media/LogoFalabellaDisabled.c17700cf8187bd0d69fbdcf711a12ab9.svg";
export { ForwardRef as ReactComponent };